import CityPageTemplate from "../city-template/CityPageTemplate";
import { battleMountainConfig } from "./data";

export default function BattleMountainPage() {
  return <CityPageTemplate config={battleMountainConfig} />;
}